<template>
  <div>
    <p>
      Below is a QR code for <a :href="qrLink" target="_blank">{{ qrLink }}</a
      >. You can scan the image with a compatible device, or click the button
      underneath to save the image.
    </p>
    <qrcode-vue
      :value="qrLink"
      :size="size"
      level="H"
      renderAs="canvas"
      class="canvas"
    />
    <p>
      <base-button isPrimary="true" @click="DownloadCanvasAsImage"
        >Download QR Code</base-button
      >
    </p>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
export default {
  data() {
    return {
      size: 300,
    };
  },
  computed: {
    qrLink() {
      return window.location.href;
    },
  },
  props: {
    link: {
      type: String,
      default: null,
      required: true,
    },
  },
  components: {
    QrcodeVue,
  },
  methods: {
    /**
     * Create a blob link from the canvas and download it
     */
    DownloadCanvasAsImage() {
      let downloadLink = document.createElement("a");
      downloadLink.setAttribute("download", `QrCode_${this.qrLink}.png`);
      let canvas = document.querySelector(".canvas canvas");
      let dataURL = canvas.toDataURL("image/png");

      // if we are IE11 then use IE11 code
      if (canvas.msToBlob) {
        const blob = canvas.msToBlob();
        window.navigator.msSaveBlob(blob, `QrCode_${this.qrLink}.png`);
        return;
      }

      let url = dataURL.replace(
        /^data:image\/png/,
        "data:application/octet-stream"
      );
      downloadLink.setAttribute("href", url);
      downloadLink.click();
    },
  },
};
</script>

<style lang="scss" scoped></style>
